import { IBaseEntityType } from '@app/shared/types/entities/base/base.type';
import { Column, CellPosition, GridApi, ColumnApi } from 'ag-grid-community';

/**
 * Keyboard navigation configuration options
 */
export interface IAgGridNavigationOptions {
  /**
   * Whether to enable input cursor boundary check (prevent navigation when cursor is not at the edge)
   */
  enableInputCursorBoundaryCheck?: boolean;

  /** Whether to always find the next editable cell */
  alwaysFindNextEditCell?: boolean;

  /** Whether to enable tree view mode, form container now */
  treeViewMode?: boolean;

  /** Tree structure child node property name, form container now */
  treeChildrenPropertyName?: string;

  /** Whether to delay focusing on internal elements */
  focusCellInnerElWithDebounce?: boolean;

  /** Custom leaf node check function */
  isLeafRow?: (data: IBaseEntityType) => boolean;

  /** List of allowed keys for navigation */
  allowedKeys?: string[];

  /** Custom editable column check function */
  customEditableCheck?: (
    column: Column,
    rowIndex: number,
    data?: IBaseEntityType,
  ) => boolean;
}

/**
 * Navigation context
 */
export interface INavigationContext {
  gridApi: GridApi;
  columnApi: ColumnApi;
  options: IAgGridNavigationOptions;
  focusedCell: CellPosition;
}

/**
 * Navigation result
 */
export interface INavigationResult {
  /** New cell position */
  position: CellPosition;

  /** Whether navigation was successful */
  success: boolean;

  /** Whether the boundary was reached */
  reachedBoundary?: boolean;

  /** Error message */
  error?: string;
}

export enum NavigationVerticalDirection {
  UP = 'up',
  DOWN = 'down',
}

export enum NavigationHorizontalDirection {
  LEFT = 'left',
  RIGHT = 'right',
}

export interface IEditableColumn {
  column: Column;
  indexInRow: number;
}
